import React from 'react';
import { StarIcon } from 'lucide-react';
interface Therapist {
  id: number;
  name: string;
  rating: number;
  reviewCount: number;
  image: string;
  specialties: string[];
}
interface TherapistCardProps {
  therapist: Therapist;
  isSelected: boolean;
  onSelect: () => void;
}
const TherapistCard = ({
  therapist,
  isSelected,
  onSelect
}: TherapistCardProps) => {
  return <div onClick={onSelect} className={`border rounded-lg overflow-hidden cursor-pointer transition-all ${isSelected ? 'border-teal-600 shadow-md' : 'border-gray-200 hover:border-teal-300'}`} data-id="element-47">
      <div className="flex p-4" data-id="element-48">
        <div className="mr-4" data-id="element-49">
          <img src={therapist.image} alt={therapist.name} className="w-16 h-16 rounded-full object-cover" data-id="element-50" />
        </div>
        <div data-id="element-51">
          <h3 className="font-medium" data-id="element-52">{therapist.name}</h3>
          <div className="flex items-center mt-1" data-id="element-53">
            <StarIcon className="h-4 w-4 text-yellow-400 fill-current" data-id="element-54" />
            <span className="ml-1 text-sm" data-id="element-55">{therapist.rating}</span>
            <span className="ml-1 text-sm text-gray-500" data-id="element-56">
              ({therapist.reviewCount} reviews)
            </span>
          </div>
          <div className="mt-2 flex flex-wrap gap-1" data-id="element-57">
            {therapist.specialties.map((specialty, index) => <span key={index} className="text-xs bg-gray-100 text-gray-800 px-2 py-1 rounded-full" data-id="element-58">
                {specialty}
              </span>)}
          </div>
        </div>
      </div>
    </div>;
};
export default TherapistCard;